export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.3c01996d.ttf";